import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { AppState } from '../../../../../core/reducers';
import { CompanyNotificationModel } from '../../../../../notification/models/company-notification.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CompanyNotificationService } from 'src/app/notification/services/company-notification.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-company-notification-edit',
  templateUrl: './company-notification-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyNotificationEditComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  companyNotification: CompanyNotificationModel;
  companyNotificationForm: FormGroup;
  configurableForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CompanyNotificationEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private layoutUtilsService: LayoutUtilsService,
    private translate: TranslateService,
    private companyNotificationsService: CompanyNotificationService,
    private store: Store<AppState>,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.companyNotification = this.data.companyNotification;
    this.createCompanyNotificationForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((el) => el.unsubscribe());
  }

  createCompanyNotificationForm() {
    this.companyNotificationForm = this.fb.group({
      is_active: [this.companyNotification.is_active],
      is_configurable: [this.companyNotification.is_configurable],
    });
  }

  getItemCssClassByStatus(isActive = false): string {
    switch (isActive) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
  }

  getItemStatusString(isActive = false): string {
    switch (isActive) {
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
    }
  }
  updateNotification() {
    const body = {
      id: this.companyNotification.id,
      level: this.data.level,
      related_id: this.data.related_id,
      is_active: this.companyNotificationForm.controls.is_active.value,
      is_configurable: this.companyNotificationForm.controls.is_configurable.value,
    };
    for (const [key, value] of Object.entries(body)) {
      if (typeof value === 'string') {
        body[key] = value.trim();
      }
    }
    this.companyNotificationsService.updateCompanyNotification(body).subscribe();
  }
}
